import React, { useContext, useState } from 'react';
import { Feather as Icons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';

import { Container, Header, IconFE, Title, Input, Button, TextButton, Content } from './styles';
import {  } from '../../../components';
import { View } from 'react-native';
import RouteContext from '../../../context/route';

const ReportProblem = () => {
    const navigation = useNavigation();
    const { setFinalizeDelivery } = useContext(RouteContext);
    const [textReport, setTextReport] = useState('');

    function backPage(){
        navigation.goBack();
    };

    async function handleReportProblem() {
        setFinalizeDelivery((prevState: any) => ({
            ...prevState,
            problem: textReport,
            order_status: '2'
        }));
        backPage();
    }

    return(
        <Container>
            <Header>
                <IconFE 
                    name="arrow-left" 
                    size={25} 
                    color="#fff"
                    onPress={backPage}
                />
                <Title>Informar problema</Title>
                <View/>
            </Header>

            <Content>
                <Input 
                    placeholder="Inclua aqui o problema que ocorreu na entrega."
                    multiline={true}
                    numberOfLines={4}
                    onChangeText={(text) => setTextReport(text)}
                />

                <Button onPress={handleReportProblem} activeOpacity={0.8}>
                    <TextButton>Enviar</TextButton>
                </Button>
            </Content>
        </Container>
    );
};

export default ReportProblem;